import { render } from "./ShadersOceanPage.vue?vue&type=template&id=68f3dc92"
import script from "./ShadersOceanPage.vue?vue&type=script&lang=js"
export * from "./ShadersOceanPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__